import { IPublishMenuRequestBody, IPublishMenuResponseBody } from './types';
import { API_URL } from '../constants';
import { postPublishRequest } from '../postPublishRequest/postPublishRequest';

export const publishMenu = (menuId: string, payload: IPublishMenuRequestBody): Promise<IPublishMenuResponseBody> =>
  postPublishRequest(`${API_URL}/publish/${menuId}`, payload, 'Something went wrong whilst publishing the menu');
